<template>
    <div id="siteDetail">
        <div
            v-if="loading"
            style="width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center"
        >
            <div>
                <md-progress-spinner
                    :md-diameter="30"
                    class="md-accent text-light"
                    md-mode="indeterminate"
                ></md-progress-spinner>
            </div>
        </div>
        <div v-else>
            <div class="header" style="height: 75px; background: #031529">
                <span>
                    <label
                        >{{ $t("message.siteAddress") }} :
                        <a :href="'https://' + site.siteAddress" target="_blank">{{ site.siteAddress }}</a></label
                    >
                </span>
                <span>
                    <a-button id="turn-back" class="btn btn primary" @click="turnBackToTheSites()">
                        {{ $t("message.turnBack") }}</a-button
                    >
                </span>
                <span>
                    {{ $t("message.createdDate") }} : {{ createdTime() }}
                    <a-button class="bg-dark border-dark text-light" @click="edit(site._id)">
                        <ActionEdit />
                    </a-button>
                </span>
            </div>
            <div class="content">
                <div class="left" style="width: 15%; background: #1e1e2d !important">
                    <a-menu
                        v-model="selectedPage"
                        :default-selected-keys="selectedPage"
                        class="h-100 w-100"
                        mode="vertical"
                        theme="dark"
                    >
                        <a-menu-item key="dashboard">
                            <a-icon type="dashboard" />
                            {{ $t("billing.Dashboard") }}
                        </a-menu-item>
                        <a-menu-item key="agents">
                            <a-icon type="customer-service" />
                            {{ $t("billing.Agents") }}
                        </a-menu-item>
                        <a-menu-item key="integration">
                            <a-icon type="safety-certificate" />
                            {{ $t("billing.Integration") }}
                        </a-menu-item>
                        <a-menu-item key="settings">
                            <a-icon type="setting" />
                            {{ $t("billing.Settings") }}
                        </a-menu-item>
                        <a-menu-item key="contacts">
                            <a-icon type="link" />
                            {{ $t("billing.Contacts") }}
                        </a-menu-item>
                        <a-menu-item key="invoices">
                            <a-icon type="gold" />
                            {{ $t("billing.invoices") }}
                        </a-menu-item>
                        <a-menu-item key="planManagment">
                            <a-icon type="fire" />
                            Plan Yönetimi
                        </a-menu-item>
                        <a-menu-item key="welcomeSupsis">
                            <a-icon type="form" />
                            Welcome Supsis
                        </a-menu-item>
                        <a-menu-item key="demoForm">
                            <a-icon type="form" />
                            Demo Formu
                        </a-menu-item>
                    </a-menu>
                </div>

                <div class="right" style="width: 85%">
                    <a-card :style="[selectedPage.includes('planManagment') && { background: 'rgb(248, 249, 250)' }]">
                        <div v-if="selectedPage.includes('dashboard')">
                            <div class="box-container">
                                <div class="box">
                                    <div class="title">{{ $t("billing.Agents") }}</div>
                                    <div class="value">
                                        {{ site.agentCount }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.Domain") }}</div>
                                    <div class="value">{{ site.integratedOrigins.length }}</div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.lastActivity") }}</div>
                                    <div class="value">{{ lastActivity() }}</div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.Integration") }}</div>
                                    <div class="value">
                                        <a-icon v-if="site.isIntegrated" style="color: green" type="check-circle" />
                                        <a-icon v-else style="color: red" type="close-circle"></a-icon>
                                    </div>
                                </div>

                                <div class="box">
                                    <div class="title">{{ $t("billing.realtimeVisitorCount") }}</div>
                                    <div class="value">{{ site.realtimeVisitorCount }}</div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.suspend") }}</div>
                                    <div class="value">
                                        <md-switch v-model="suspend" class="md-primary">
                                            <span v-if="site.suspend">{{ $t("message.active") }}</span>
                                            <span v-else>{{ $t("message.passive") }}</span>
                                        </md-switch>
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.partner") }}</div>
                                    <div class="value">{{ $_.get(site, "partner.name") }}</div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.trialDay") }}</div>
                                    <strong>{{ trialDay }} - {{ $t("billing.trialDay") }}</strong>
                                    <small>{{ getRemainingTrialDay() }} - {{ $t("billing.daysLeft") }}</small>
                                    <a-button shape="circle" @click="showTrialPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">Billing Wizard</div>
                                    <div class="value">
                                        <md-switch v-model="planWizardCompleted" class="md-primary">
                                            <span v-if="site.settings.planWizardCompleted">{{
                                                $t("message.active")
                                            }}</span>
                                            <span v-else>{{ $t("message.passive") }}</span>
                                        </md-switch>
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="title">Payment Method</div>
                                    <div class="value">
                                        <a-select v-model="paymentMethod">
                                            <a-select-option value="btc">BTC</a-select-option>
                                            <a-select-option value="eft">EFT/HAVALE</a-select-option>
                                            <a-select-option value="credit-card">KREDI KARTI</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="title">GENEL INDIRIM</div>
                                    <strong>{{ totalDiscount }}%</strong>
                                    <a-button shape="circle" @click="showTotalDiscountPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">Whatsapp Bakiye</div>
                                    <strong>{{ whatsappWallet }}TL</strong>
                                    <a-button shape="circle" @click="showWhasappWalletPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">Whatsapp Alt Limit</div>
                                    <strong>{{ maxLowBalance }}TL</strong>
                                    <a-button shape="circle" @click="showWhasappLowLimitPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">Whatsapp Gupshup Commission</div>
                                    <strong>{{ gupshupCommission }}%</strong>
                                    <a-button shape="circle" @click="showGupshupCommissionPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">Email Gönderim Limiti</div>
                                    <strong>{{ monthlyMailSendLimit }}</strong>
                                    <a-button shape="circle" @click="showMonthlyMailSendLimitPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>

                                <div class="box">
                                    <div class="title">Whatsapp Commission</div>
                                    <strong>{{ whatsappCommission }}%</strong>
                                    <a-button shape="circle" @click="showWhatsappCommissionPrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">Whatsapp Mesaj Fiyatı</div>
                                    <strong>{{ whatsappPerMessagePrice }}TL</strong>
                                    <a-button shape="circle" @click="showWhatsappPerMessagePrompt">
                                        <a-icon type="edit" />
                                    </a-button>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.mobile") }}</div>
                                    <div class="value">
                                        <a-icon
                                            v-if="site.mobileUserCount > 0"
                                            style="color: green"
                                            type="check-circle"
                                        />
                                        <a-icon v-else style="color: red" type="close-circle"></a-icon>
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.webSite") }}</div>
                                    <div class="value">
                                        <a
                                            :href="`${IS_DEV_ENVIRONMENT ? 'http' : 'https'}://${
                                                site.settings.website
                                            }`"
                                            style="text-decoration: underline"
                                            target="_blank"
                                        >
                                            <a-icon type="link" />
                                            {{ site.settings.website }}</a
                                        >
                                    </div>
                                </div>

                                <div class="box">
                                    <div class="title">{{ $t("billing.websiteOrigins") }}</div>
                                    <div class="value">
                                        <div
                                            v-for="dom in site.integratedOrigins"
                                            :value="dom"
                                            style="width: 200px; padding: 3px"
                                        >
                                            <a
                                                :href="`${IS_DEV_ENVIRONMENT ? 'http' : 'https'}://${dom}`"
                                                style="text-decoration: underline"
                                                target="_blank"
                                            >
                                                <a-icon type="link" />
                                                {{ dom }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex" style="justify-content: center">
                                <a-button class="bg-danger border-dark text-light" @click="del(site)">
                                    <div class="mr-1" style="font-size: 1.5rem; font-weight: bold">
                                        {{ $t("message.deleteThisSite") }}
                                    </div>
                                </a-button>
                            </div>
                        </div>
                        <div v-if="selectedPage.includes('agents')">
                            <UserList :site-id="site._id" />
                        </div>
                        <div v-if="selectedPage.includes('integration')">{{ $t("message.integration") }}</div>
                        <div v-if="selectedPage.includes('settings')">{{ $t("message.setting") }}</div>
                        <div v-if="selectedPage.includes('invoices')">
                            <InvoiceList :initial-data="site" :site-address="site.clientAddress" />
                        </div>
                        <div v-if="selectedPage.includes('contacts')">
                            <div class="box-container">
                                <div class="box">
                                    <div class="title">{{ $t("billing.ownerName") }}</div>
                                    <div class="value">
                                        {{ site.rootUserName }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="title">{{ $t("billing.ownerEmailAddress") }}</div>
                                    <div class="value">
                                        {{ site.rootUserEmail }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedPage.includes('planManagment')" class="plans-page">
                            <div v-if="showingBillingPlans">
                                <div class="material-icons go-back-button" @click="goBack">arrow_back</div>
                                <CustomerPlans
                                    :is-admin="true"
                                    :site-id="site._id"
                                    :site-appsumo-coupons="site.appsumoCoupons"
                                    :site-current-plans="currentPlans"
                                    :site-plans="plans"
                                    :type="showingBillingPlans"
                                    @go-back="goBack"
                                />
                            </div>
                            <div v-else>
                                <a-modal
                                    :visible="deleteItem"
                                    icon="exclamation-circle"
                                    :title="'Delete Package'"
                                    @cancel="deleteItem = null"
                                >
                                    <p>Bu paketi silmek istediğinizden eminmisiniz kalıcı olarak silinecektir.</p>
                                    <template #footer>
                                        <a-button key="back" @click="deleteItem = null">
                                            {{ $t("chatbotv2.dismiss") }}
                                        </a-button>
                                        <a-button key="submit" type="danger" @click="deletePackage">
                                            {{ $t("chatbotv2.delete") }}
                                        </a-button>
                                    </template>
                                </a-modal>
                                <CreateNewPlanModal
                                    v-if="modalShowing"
                                    v-model="form"
                                    @cancel="modalShowing = false"
                                    @create="createNewPlan"
                                    @update="planUpdate"
                                />

                                <div class="header-top">
                                    <div class="title">Mevcut Planlar</div>
                                </div>
                                <CurrentPlans
                                    :class="'current-plans'"
                                    :site-id="site._id"
                                    :site-current-plans="currentPlans"
                                    :site-plans="plans"
                                    @show="showPlans"
                                />
                                <div class="header-plans-top">
                                    <div class="create-plan" @click="modalShowing = true">Plan Oluştur</div>
                                </div>
                                <div class="plan-container" v-for="planName of Object.keys(groupedPlans)">
                                    <div class="plan-title">
                                        {{
                                            planName
                                                .split("-")
                                                .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                                                .join(" ")
                                        }}
                                        Paketleri
                                    </div>
                                    <div class="plan-items-wrapper">
                                        <transition name="scale">
                                            <button id="prev-button" v-show="groupedPlans[planName].length > 4">
                                                <md-icon class="navigate-arrow navigate-left"
                                                    >arrow_back_ios_new
                                                </md-icon>
                                            </button>
                                        </transition>
                                        <div class="plan-items">
                                            <Card
                                                v-for="item of groupedPlans[planName]"
                                                :plan="item"
                                                :key="item._id"
                                                :editable-card="true"
                                                :self-site="true"
                                                @edit-action="editPlan(item)"
                                                @delete-action="deleteItem = item"
                                                :visibilityDetails="site.visibilityPlanSettings"
                                                @visibilityChanged="visibilityChange"
                                                class="plan"
                                            />
                                        </div>
                                        <transition name="scale">
                                            <button id="next-button" v-show="groupedPlans[planName].length > 4">
                                                <md-icon class="navigate-arrow navigate-right"
                                                    >arrow_forward_ios
                                                </md-icon>
                                            </button>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedPage.includes('demoForm')">
                            <DemoFormViews :site-id="site._id" :site-data="site" />
                        </div>
                        <div v-if="selectedPage.includes('welcomeSupsis')">
                            <WelcomeSupsisViews :site-id="site._id" :site-data="site" />
                        </div>
                    </a-card>
                </div>
            </div>
        </div>

        <SiteCreateModalForm
            :edit-mode="true"
            :on-cancel="onModalFormCancel"
            :on-success="onModalFormSuccess"
            :updating-site="updatingSite"
            :visible="modalVisible"
            :is-modal-show="isNewModal"
            :close-modal="hideNewModalForm"
        />
    </div>
</template>

<script>
import log2 from "../../utils/log2";
import { IS_DEV_ENVIRONMENT, IS_STAGE_ENVIRONMENT } from "../../utils/utils";
import {
    createPlan,
    deletePlan,
    getBalanceById,
    getSiteCurrentPlansById,
    getSiteDetail,
    getSitePlansById,
    setBalanceById,
    updatePlan,
    updateSiteSingleKey,
} from "../../api/site";
import ActionDelete from "../../components/svg/ActionDelete.vue";
import ActionEdit from "../../components/svg/ActionEdit.vue";
import * as _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";
import { mapActions, mapGetters, mapState } from "vuex";
import Sites from "./Sites/Sites.vue";
import * as echarts from "echarts";
import lineNew from "../Reports/old/data/lineNew";
import { createComponent } from "echarts-for-vue";
import InstallationInstarctionPage from "../Pages/InstallationInstarctionPage.vue";
import SiteCreateModalForm from "../../components/SiteCreateModalForm.vue";
import InvoiceList from "../../components/billing/InvoiceList.vue";
import UserList from "../../components/UserList.vue";
import { forceUpdateSettings } from "../../api/setting";
import Card from "../../components/billing/Card.vue";
import CreateNewPlanModal from "../../components/billing/CreateNewPlanModal.vue";
import moment from "moment";
import CancelPlanModal from "../../components/billing/CancelPlanModal.vue";
import CreatePlanModal from "../../components/billing/CreatePlanModal.vue";
import ChangePlan from "../../components/billing/new/ChangePlan.vue";
import CustomerPlans from "../Pages/Billing/components/old/CustomerPlans.vue";
import CurrentPlans from "../Pages/Billing/components/old/CurrentPlans.vue";
import DemoFormViews from "../DemoFormViews.vue";
import WelcomeSupsisViews from "./Sites/WelcomeSupsisViews.vue"

const log = log2("SiteDetail");
const selfServiceInitialObject = {
    rootUserName: undefined,
    rootUserEmail: undefined,
    password: undefined,
    organizationName: undefined,
    subdomain: undefined,
};
export default {
    name: "SiteDetail",
    props: {},
    components: {
        CustomerPlans,
        CancelPlanModal,
        CreatePlanModal,
        ChangePlan,
        ActionEdit,
        ActionDelete,
        Sites,
        SiteCreateModalForm,
        InstallationInstarctionPage,
        InvoiceList,
        UserList,
        ECharts: createComponent({ echarts }),
        Card,
        CreateNewPlanModal,
        CurrentPlans,
        DemoFormViews,
        WelcomeSupsisViews
    },
    data() {
        return {
            IS_DEV_ENVIRONMENT,
            loading: true,
            siteAddress: "",
            site: null,
            updatingSite: null,
            selectedPage: ["dashboard"],
            line: lineNew([
                // value timestamp olacak
                { name: "aa", value: 1 },
                { name: "bb", value: 10 },
                { name: "cc", value: 14 },
                { name: "dd", value: 10 },
                { name: "ab", value: 14 },
                { name: "bbb", value: 13 },
                { name: "ac", value: 11 },
                { name: "ad", value: 8 },
            ]),
            isBusy: true,
            modalVisible: false,
            selfService: _.cloneDeep(selfServiceInitialObject),
            showUpdatableData: false,
            plans: [],
            currentPlans: [],
            groupedPlans: {},
            modalShowing: false,
            editingPlan: false,
            deleteItem: null,
            form: null,
            showingBillingPlans: false,
            period: "monthly",
            details: {
                agentCount: 1,
                whatsappChannel: 1,
            },
            isNewModal: false,
            balance: {},
        };
    },
    mounted() {
        const name = this.$route.params.siteAddress;
        if (IS_DEV_ENVIRONMENT) {
            if (name === "local") this.siteAddress = "local.supsis.live";
            else this.siteAddress = `${name}.local.supsis.live`;
        } else if (IS_STAGE_ENVIRONMENT) {
            if (name === "beta") this.siteAddress = "beta.supsis.live";
            else this.siteAddress = `${name}.beta.supsis.live`;
        } else {
            if (name === "supsis") this.siteAddress = "supsis.live";
            else this.siteAddress = `${name}.supsis.live`;
        }
        this.fetchData();
        this.$nextTick(() => {
            this.sliderCalculator();
        });
    },

    computed: {
        ...mapState({}),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        suspend: {
            get() {
                return this.site?.suspend || false;
            },
            set() {
                this.toggleSuspendState();
            },
        },
        planWizardCompleted: {
            get() {
                return _.get(this.site, "settings.planWizardCompleted");
            },
            async set(value) {
                await this.forceUpdateSettings({
                    planWizardCompleted: value,
                });
                this.$set(this.site.settings, "planWizardCompleted", value);
            },
        },
        paymentMethod: {
            get() {
                return this.site?.paymentMethod || "credit-card";
            },
            async set(value) {
                this.updatePaymentMethod(value);
            },
        },
        trialDay: {
            get() {
                return _.get(this.site, "settings.plan.trialDays");
            },
            set(newTrialDayCount) {
                this.updateTrialDay(newTrialDayCount);
            },
        },
        whatsappWallet: {
            get() {
                return _.get(this.balance, "whatsapp.amount", 0);
            },
            set(newAmount) {
                setBalanceById({
                    siteId: this.site._id,
                    walletType: "whatsapp",
                    amount: newAmount,
                }).then((wallet) => {
                    this.balance = {
                        ...this.balance,
                        whatsapp: wallet,
                    };
                });
            },
        },
        maxLowBalance: {
            get() {
                return _.get(this.site, "maxLowBalance", -100);
            },
            set(limit) {
                this.updateWhatsappBalanceLimit(limit);
            },
        },
        gupshupCommission: {
            get() {
                return _.get(this.site, "gupshupCommission", 30);
            },
            set(percent) {
                this.updateGupshupCommission(percent);
            },
        },
        whatsappCommission: {
            get() {
                return _.get(this.site, "whatsappCommission", 30);
            },
            set(percent) {
                this.updateWhatsappCommission(percent);
            },
        },
        whatsappPerMessagePrice: {
            get() {
                return _.get(this.site, "whatsappPerMessagePrice", 0.25);
            },
            set(price) {
                this.updateWhatsappPerMessage(price);
            },
        },
        totalDiscount: {
            get() {
                return _.get(this.site, "totalDiscount", 0);
            },
            set(price) {
                this.updateTotalDiscount(price);
            },
        },
        monthlyMailSendLimit: {
            get() {
                return _.get(this.site, "monthlyMailSendLimit", 0);
            },
            set(limit) {
                this.updateMonthlyMailSendLimit(limit);
            },
        },
    },
    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },
    methods: {
        ...mapActions({
            getSite: "site/getSite",
            getSites: "site/getSites",
            createSite: "site/createSite",
            updateSite: "site/updateSite",
            delSite: "site/delSite",
        }),
        sliderCalculator() {
            const planItemsWrappers = document.querySelectorAll(".plan-items-wrapper");

            planItemsWrappers.forEach((wrapper) => {
                const planItems = wrapper.querySelector(".plan-items");
                const cards = planItems.querySelectorAll(".card");
                const nextButton = wrapper.querySelector("#next-button");
                const prevButton = wrapper.querySelector("#prev-button");
                prevButton.style.display = "none";
                const listener = (e) => {
                    const target = e.target;
                    let cardWidth = 0;
                    if (cards.length > 0) {
                        cardWidth = cards[0].offsetWidth;
                    }
                    const visibleCards = Math.floor(target.clientWidth / cardWidth);

                    if (target.scrollLeft <= 100 && cards.length <= 3) {
                        prevButton.style.display = "none";
                        nextButton.style.display = "block";
                    } else if (target.scrollLeft + 0.5 >= target.scrollWidth - target.clientWidth) {
                        nextButton.style.display = "none";
                        prevButton.style.display = "block";
                    } else {
                        prevButton.style.display = "block";
                        nextButton.style.display = "block";
                    }
                };

                planItems.addEventListener("scroll", listener);

                nextButton.addEventListener("click", () => {
                    planItems.scrollBy(700, 0);
                });

                prevButton.addEventListener("click", () => {
                    planItems.scrollBy(-700, 0);
                });
            });
        },
        showPlans(type) {
            this.showingBillingPlans = type;
        },
        goBack() {
            this.showingBillingPlans = null;
        },
        visibilityChange(plan, visibility) {
            let visibilityPlanSettings = { ...this.site.visibilityPlanSettings };
            if (visibility) {
                visibilityPlanSettings[plan._id] = true;
            } else {
                delete visibilityPlanSettings[plan._id];
            }

            updateSiteSingleKey(this.site._id, "visibilityPlanSettings", visibilityPlanSettings)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success("Plan Görünürlüğü Ayarlandı.", 3);
                        this.site.visibilityPlanSettings = visibilityPlanSettings;
                    } else {
                        this.$message.error("Bir hata oluştu, işlem gerçekleşmedi.", 3);
                    }
                })
                .catch(log.error);
        },
        async getSitePlans(siteId) {
            const plans = await getSitePlansById(siteId);
            const activePlans = plans.filter((plan) => plan.type !== "extra-package").filter((plan) => !plan.isDeleted);
            this.groupedPlans = _.groupBy(activePlans, (p) => p.dynamicType || p.type);
            this.plans = activePlans;
        },
        async getSiteCurrentPlans(siteId) {
            this.currentPlans = await getSiteCurrentPlansById(siteId);
        },
        async deletePackage() {
            await deletePlan(this.deleteItem._id);
            const type = this.deleteItem.dynamicType || this.deleteItem.type;
            this.groupedPlans[type] = (this.groupedPlans[type] || []).filter(
                (plan) => plan._id !== this.deleteItem._id
            );
            this.deleteItem = null;
        },
        createNewPlan(form) {
            createPlan({
                ...form,
                siteId: this.site._id,
            }).then(async () => {
                await this.getSitePlans(this.site._id);
                this.modalShowing = false;
            });
        },
        planUpdate(form) {
            if (!form.siteId) {
                this.createNewPlan({
                    ...form,
                    siteId: this.site._id,
                    refPlan: form._id,
                });
            } else {
                updatePlan(form._id, form).then((plan) => {
                    const newPlanType = plan.dynamicType || plan.type;
                    const editedPlanType = form.dynamicType || form.type;
                    const type = newPlanType === editedPlanType ? newPlanType : editedPlanType;
                    this.groupedPlans[type] = (this.groupedPlans[type] || []).map((p) => {
                        if (p._id === plan._id) p = plan;
                        return p;
                    });
                    this.modalShowing = false;
                });
            }
        },
        editPlan(plan) {
            this.form = { ...plan };
            this.modalShowing = true;
        },
        getRemainingTrialDay() {
            const createdDate = this.site.createdAt;
            const trialDay = _.get(this.site, "settings.plan.trialDays");
            if (!isNaN(trialDay)) {
                const diff = moment().diff(moment(createdDate, "YYYY-MM-DDTHH:mm:ss"), "days");
                if (diff < trialDay) {
                    return trialDay - diff;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        },
        showTrialPrompt() {
            let value = window.prompt(this.$t("billing.newTrialPopUp"), _.get(this.site, "settings.plan.trialDays"));
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                log("trial day", { value, old: _.get(this.site, "settings.plan.trialDays") });
                if (_.get(this.site, "settings.plan.trialDays") !== value) {
                    this.trialDay = value;
                }
            }
        },
        showWhasappWalletPrompt() {
            let value = window.prompt("Müşterinin Whatsapp Bakiyesini Düzenleyin.", this.whatsappWallet);
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                if (this.whatsappWallet !== value) {
                    this.whatsappWallet = value;
                }
            }
        },
        showTotalDiscountPrompt() {
            let value = window.prompt("Müşteriye sağlanacak %'lik indirimi giriniz.", this.totalDiscount);
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                if (this.totalDiscount !== value) {
                    this.totalDiscount = value;
                }
            }
        },
        showWhasappLowLimitPrompt() {
            let value = window.prompt("Müşterinin Whatsapp Bakiyesini Limitini Düzenleyiniz.", this.maxLowBalance || 0);
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                if (this.maxLowBalance !== value) {
                    this.maxLowBalance = value;
                }
            }
        },
        showGupshupCommissionPrompt() {
            let value = window.prompt("Whatsapp bussiness komisyon oranı kaç olsun.", this.gupshupCommission || 0);
            if (!!value && value !== "" && !isNaN(value)) {
                value = +value;
                if (this.gupshupCommission !== value) {
                    this.gupshupCommission = value;
                }
            }
        },

        showWhatsappCommissionPrompt() {
            let value = window.prompt("Whatsapp komisyon oranı kaç olsun.", this.whatsappCommission || 0);
            if (!!value && value !== "" && !isNaN(value)) {
                value = +value;
                if (this.whatsappCommission !== value) {
                    this.whatsappCommission = value;
                }
            }
        },

        showWhatsappPerMessagePrompt() {
            let value = window.prompt("Whatsapp Mesaj başına komisyon fiyatı.", this.whatsappPerMessagePrice || 0);
            if (!!value && value !== "" && !isNaN(value)) {
                value = +value;
                if (this.whatsappPerMessagePrice !== value) {
                    this.whatsappPerMessagePrice = value;
                }
            }
        },
        showWhatsappPricePrompt() {
            let value = window.prompt(this.$t("billing.newWpPricePopUp"), _.get(this.site, "whatsappBasePrice.value"));
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                log("whatsapp price", { value, old: _.get(this.site, "whatsappBasePrice.value") });
                if (_.get(this.site, "whatsappBasePrice.value") !== value) {
                    _.set(this.site, "whatsappBasePrice.value", value);
                    updateSiteSingleKey(this.site._id, "whatsappBasePrice.value", value);
                }
            }
        },
        showWhatsappPlusPricePrompt() {
            let value = window.prompt(
                this.$t("billing.newWpPricePopUp"),
                _.get(this.site, "whatsappPlusBasePrice.value")
            );
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                log("whatsappPlusBasePrice price", { value, old: _.get(this.site, "whatsappPlusBasePrice.value") });
                if (_.get(this.site, "whatsappPlusBasePrice.value") !== value) {
                    _.set(this.site, "whatsappPlusBasePrice.value", value);
                    updateSiteSingleKey(this.site._id, "whatsappPlusBasePrice.value", value);
                }
            }
        },
        showInstagramPricePrompt() {
            let value = window.prompt(
                this.$t("billing.newWIGPricePopUp"),
                _.get(this.site, "instagramBasePrice.value")
            );
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                log("instagram price", { value, old: _.get(this.site, "instagramBasePrice.value") });
                if (_.get(this.site, "instagramBasePrice.value") !== value) {
                    _.set(this.site, "instagramBasePrice.value", value);
                    updateSiteSingleKey(this.site._id, "instagramBasePrice.value", value);
                }
            }
        },
        showInstagramPlusPricePrompt() {
            let value = window.prompt(
                this.$t("billing.newIGPricePopUp"),
                _.get(this.site, "instagramPlusBasePrice.value")
            );
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                log("instagramPlusBasePrice price", { value, old: _.get(this.site, "instagramPlusBasePrice.value") });
                if (_.get(this.site, "instagramPlusBasePrice.value") !== value) {
                    _.set(this.site, "instagramPlusBasePrice.value", value);
                    updateSiteSingleKey(this.site._id, "instagramPlusBasePrice.value", value);
                }
            }
        },
        showBasePricePrompt() {
            let value = window.prompt(this.$t("billing.newBasePricePopUp"), _.get(this.site, "basePrice.value"));
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                log("base price", { value, old: _.get(this.site, "basePrice.value") });
                if (_.get(this.site, "basePrice.value") !== value) {
                    this.site.basePrice.value = value;
                    updateSiteSingleKey(this.site._id, "basePrice.value", value);
                }
            }
        },
        showMonthlyMailSendLimitPrompt() {
            let value = window.prompt("Aylık mail gönderim limitini düzenleyin.", this.monthlyMailSendLimit);
            if (!!value && value !== "" && !isNaN(value)) {
                value = parseInt(value);
                if (this.monthlyMailSendLimit !== value) {
                    this.monthlyMailSendLimit = value;
                }
            }
        },
        updateMonthlyMailSendLimit(limit) {
            log("updateMonthlyMailSendLimit event");
            updateSiteSingleKey(this.site._id, "monthlyMailSendLimit", limit)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.monthlyMailSendLimit = limit;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        turnBackToTheSites() {
            this.$router.go(-1);
        },
        toggleSuspendState() {
            log("toggleSuspendState event");
            updateSiteSingleKey(this.site._id, "suspend", !this.site.suspend)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.suspend = !this.site.suspend;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        updatePaymentMethod(type) {
            log("updatePaymentMethod event");
            updateSiteSingleKey(this.site._id, "paymentMethod", type)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.paymentMethod = type;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        updateWhatsappBalanceLimit(limit) {
            log("updateWhatsappBalanceLimit event");
            updateSiteSingleKey(this.site._id, "maxLowBalance", limit)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.maxLowBalance = limit;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        updateGupshupCommission(percent) {
            log("updateGupshupCommission event");
            updateSiteSingleKey(this.site._id, "gupshupCommission", percent)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.gupshupCommission = percent;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        updateWhatsappCommission(percent) {
            log("updateWhatsappCommission event");
            updateSiteSingleKey(this.site._id, "whatsappCommission", percent)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.whatsappCommission = percent;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        updateWhatsappPerMessage(price) {
            log("updateWhatsappPerMessage event");
            updateSiteSingleKey(this.site._id, "whatsappPerMessagePrice", price)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.whatsappPerMessagePrice = price;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        updateTotalDiscount(discount) {
            log("updateTotalDiscount event");
            updateSiteSingleKey(this.site._id, "totalDiscount", discount)
                .then((res) => {
                    if (!!res.data) {
                        this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                        this.site.totalDiscount = discount;
                    } else {
                        this.$message.error(this.$t("billing.siteInfoNotUpdated"), 3);
                    }
                })
                .catch(log.error);
        },
        async updateTrialDay(newTrialDayCount) {
            log("updateTrialDay event");
            await this.forceUpdateSettings({
                "plan.trialDays": newTrialDayCount,
            });
            this.$set(this.site.settings, "plan.trialDays", newTrialDayCount);
        },
        onModalFormSuccess() {
            this.fetchData();
            this.modalVisible = false;
            log("onMoodalCancell Çalıştı!!!!!**********************");
        },
        onModalFormCancel() {
            log("onMoodalCancell Çalıştı!!!!!**********************");
            this.modalVisible = false;
        },
        siteSocketCountWithSiteName() {
            this.$root.$emit("ClusterDashboard"); //like this
        },
        startVisitorCountTimer(siteId) {
            if (this.timerId) clearInterval(this.timerId);
            const servers = {
                development: "http://socket-local.supsis.live/hosts",
                stage: "https://beta-socket.supsis.live/hosts",
                production: "https://socket.supsis.live/hosts",
            };
            const currentServer = servers[process.env.ENVIRONMENT];
            this.timerId = setInterval(() => {
                fetch(currentServer)
                    .then((x) => x.json())
                    .then((hosts) => {
                        const realtimeVisitorCount = hosts
                            .map((host) => host.siteSocketCountMap[siteId] || 0)
                            .reduce((acc, current) => {
                                acc += current;
                                return acc;
                            }, 0);
                        if (this.site && this.site.realtimeVisitorCount !== realtimeVisitorCount) {
                            this.site.realtimeVisitorCount = realtimeVisitorCount;
                            this.site = { ...this.site };
                        }
                    });
            }, 3000);
        },
        lastActivity() {
            if (this.site.lastLoginTS) return this.$moment(this.site.lastLoginTS).fromNow();
            else return "-";
        },
        createdTime() {
            return this.$moment(this.site.createdAt).fromNow();
        },
        fetchData() {
            log("fetchData", this.siteAddress);
            this.loading = true;
            getSiteDetail(this.siteAddress)
                .then((response) => {
                    const site = response.data;
                    site.isIntegrated =
                        site.integratedOrigins.filter((x) => x.indexOf(".supsis.live") === -1).length > 0;
                    site.mobileUserCount = site.users.filter((x) => !!x.mobileNotification).length;
                    site.webUserCount = site.users.length - site.mobileUserCount;
                    this.site = site;
                    this.getSitePlans(site._id);
                    this.getSiteCurrentPlans(site._id);
                    this.startVisitorCountTimer(site._id);
                    getBalanceById(site._id).then((balance) => {
                        const mapBalance = balance.reduce((acc, wallet) => {
                            acc[wallet.type] = wallet;
                            return acc;
                        }, {});
                        this.balance = mapBalance;
                    });
                })
                .catch((err) => {
                    log.error("site fetch error", err);
                    this.site = null;
                })
                .finally(() => [(this.loading = false)]);
        },

        edit(id) {
            log("edit called", id);
            const site = _.cloneDeep(this.site);
            ["integratedOrigins", "agentCount", "lastLoginTS", "settings", "users"].forEach((key) => {
                delete site[key];
            });
            this.updatingSite = _.cloneDeep(site);
            this.modalVisible = true;
            this.isNewModal = true;
        },
        del(site) {
            this.$dialog
                .confirm(this.$t("message.deleteSite", { siteName: _.get(site, "clientAddress") }), {
                    okText: this.$t("message.yes"),
                    cancelText: this.$t("message.no"),
                })
                .then(() => {
                    this.delSite(site._id).then((response) => {
                        sendSocketMessage("admin site-delete", { siteId: site._id });
                    });
                });
        },
        async forceUpdateSettings(updatingSettingFields) {
            await forceUpdateSettings(this.site._id, updatingSettingFields)
                .then((x) => {
                    this.$message.success(this.$t("billing.siteInfoUpdated"), 3);
                    this.fetchData();
                })
                .catch((err) => {
                    log.error("forceUpdateSettings error", err);
                    this.$message.error(this.$t("billing.siteInfoNotUpdatedErr"), 3);
                });
        },
        hideNewModalForm() {
            this.isNewModal = false;
        },
    },
    updated() {
        log("updated", this.sites);
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
    },
    watch: {
        modalShowing(newVal) {
            if (!newVal) {
                this.form = null;
            }
        },
        selectedPage(newVal) {
            this.$nextTick(() => {
                const adminPlans = document.querySelector(".plan-items");
                if (adminPlans) {
                    if (newVal.includes("planManagment")) {
                        this.sliderCalculator();
                    } else {
                        adminPlans.removeEventListener("scroll", this.listener);
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss">
#siteDetail {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .go-back-button {
        background: rgb(236, 75, 29);
        padding: 10px;
        border-radius: 40px;
        font-size: 16px;
        color: white;
    }

    #turn-back {
        border: none;
        background: none;
        color: #3590ff;
        font-size: 16px;
        font-weight: 450;
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding: 5px;
        align-items: flex-end;
        font-size: 20px;
        font-weight: bolder;
        color: #3590ff;

        span {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        button {
            float: right;
            margin-left: 10px;
        }
    }

    .content {
        display: flex;
        width: 100%;
        min-height: calc(100vh - 100px);
        border: 1px solid black;

        .left {
            min-height: 100%;
            border-right: 1px solid darkgray;

            ul {
                li:first-child {
                    margin-top: 0px !important;
                }
            }
        }

        .right {
            min-height: 100%;

            .ant-card {
                height: 100%;
            }

            .box-container {
                display: flex;
                flex-wrap: wrap;

                .box {
                    border: 1px solid darkgray;
                    padding: 15px;
                    background-color: rgba(248, 243, 243, 0.86);
                    flex: 1 0 24%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin: 8px 3px 8px 3px;

                    .title {
                        font-size: 20px;
                        color: black;
                        letter-spacing: 2px;
                        text-transform: uppercase;
                    }

                    .value {
                        font-size: 15px;
                        font-weight: 600;
                        margin-top: 3px;
                    }
                }

                #switches-wrapper {
                    width: 20%;
                    height: 75px;
                    margin-left: 40%;
                    margin-right: 40%;
                }

                .new-line-box {
                    width: 100%;
                    height: 75px;
                    padding: 10px 0px 10px 0px;
                    background: #f9f5f5;
                }
            }
        }
    }

    .echarts {
        width: 100% !important;
        height: 100% !important;
    }

    .echarts div:last-child {
        transform: rotate(90deg) !important;
    }

    .plans-page {
        width: calc(100vw - 400px);

        .header-top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                font-weight: bold;
                font-size: 20px;
                color: black;
            }
        }

        .current-plans {
            margin-top: 20px;
            display: grid;
            grid-template-columns: auto auto auto;
            gap: 10px;
        }

        .header-plans-top {
            display: flex;
            justify-content: end;
            align-items: center;
            margin-top: 15px;

            .create-plan {
                padding: 10px 20px;
                background: rgb(236, 75, 29);
                border-radius: 100px;
                color: white;
            }
        }

        .plan-container {
            margin-top: 20px;

            .plan-title {
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 10px;
                color: rgb(23, 23, 37);
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .plan-items {
                display: flex;
                margin-top: 10px;

                :last-child {
                    margin-right: 0;
                }

                .supsis-plan {
                    margin-right: 25px;
                }
            }
        }

        .ant-slider-handle {
            background: rgb(236, 75, 29);
            border-color: rgb(236, 75, 29);

            :focus {
                box-shadow: none;
                -webkit-box-shadow: none;
            }
        }

        .ant-slider-track {
            background: rgb(236, 75, 29);
        }

        .plan-items-wrapper {
            overflow: hidden !important;
            border: none !important;
            min-height: auto !important;
            position: relative;

            .plan-items {
                max-width: 90%;
                display: flex;
                overflow: auto !important;
                gap: 28px;
                padding: 35px;
                scroll-behavior: smooth;

                &::-webkit-scrollbar {
                    display: none;
                }

                .plan {
                    min-width: 18vw !important;
                }
            }

            .navigate-arrow {
                color: white !important;
                font-size: 24px !important;
                font-weight: 800 !important;
            }

            #prev-button {
                position: absolute;
                left: 15px;
                top: 50%;
                z-index: 99999;
                height: 60px;
                width: 60px;
                border-radius: 50%;
                background-color: rgb(236, 75, 29) !important;
                border: none;

                .navigate-left {
                    margin-right: 2px !important;
                }
            }

            #next-button {
                position: absolute;
                right: 15px;
                top: 50%;
                z-index: 99999;
                height: 60px;
                width: 60px;
                border-radius: 50%;
                background-color: rgb(236, 75, 29) !important;
                border: none;

                .navigate-right {
                    margin-left: 2px !important;
                }
            }
        }
    }
}
</style>
